import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 0px 16px 16px;
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid var(--line-secondary-n-300, #E0E0E8);
  background: var(--bg-primary-n-0, #FFF);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const Heading = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; 
`;

export const Description = styled.div`
  color: var(--text-secondary-n-400, #5B5675);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; 
`;

export const LearnMore = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--button-hyperlink-b-300, #1b73e8);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
`;

export const Image = styled.img`
  flex-shrink: 0;
  object-fit: contain;
  border-radius: 8px;
`;
